import {Injectable} from '@angular/core';
import {HttpService} from './http.service';
import {OrgLinks} from "../shared-module/models/org-links";
import {SmsTemplate} from "../shared-module/models/sms-templates.model";
import {WebResult} from "../shared-module/models/web-result";

/**
 * Created by Rumyantsev Daniil on 08.09.2017.
 */

enum ErrorTokens{
  SMS_TEMPLATE_ALREADY_EXISTS = "SMS_TEMPLATE_ALREADY_EXISTS",
}

@Injectable()
export class OrganizationService {

  constructor(private httpService: HttpService) {
  }

  public async isAliasExist(alias: string) {
    const sb = [];
    sb.push('rest/isAliasExistExtended?');
    sb.push('&alias=');
    sb.push(alias);
    let result = false;
    await this.httpService.getData(sb.join(''))
      .then((isAliasExist) => {
        console.log("in org service isAliasExist result: ", isAliasExist);
        result = isAliasExist;
      });
    return result;
  }

  public async createSmsTemplate(template: SmsTemplate) {
    const sb = [];
    sb.push('rest/createSmsTemplate');

    let result = false;
    await this.httpService.postDataWithAuth(sb.join(''), template)
      .then(() => {
      }, (error) => {
        let errorToken: WebResult = JSON.parse(error._body);
        throw this.getErrorMessage(errorToken)
      });
    return result;
  }

  public async editSmsTemplate(template: SmsTemplate, oldName: string ) {
    const sb = [];
    sb.push('rest/editSmsTemplate?');
    sb.push('oldName=');
    sb.push(oldName);

    let result = false;
    await this.httpService.postDataWithAuth(sb.join(''), template)
      .then(() => {
      }, (error) => {
        throw error;
      });
    return result;
  }

  public async deleteSmsTemplate(template: SmsTemplate) {
    const sb = [];
    sb.push('rest/deleteSmsTemplate?');

    let result = false;
    await this.httpService.postDataWithAuth(sb.join(''), template)
      .then(() => {
      }, (error) => {
        throw error;
      });
    return result;
  }

  public async getInactiveInfo(alias: string) {
    const sb = [];
    sb.push('rest/getInactiveInfo?');
    sb.push('&alias=');
    sb.push(alias);
    let result = false;
    await this.httpService.getData(sb.join(''))
      .then((info) => {
          result = info.text;
        },
        (rejected) => {
          throw new class implements Error {
            message: string;
            name: string;
            stack: string;
          }
        });
    return result;
  }

  public static getOrgLinks(): OrgLinks {
    return JSON.parse(localStorage.getItem("orgLinks"));
  }

  public async getLinks(alias: string): Promise<OrgLinks> {
    const sb = [];
    sb.push('rest/');
    sb.push(alias);
    sb.push('/getLinks');
    return await this.httpService.getData(sb.join(''))
      .then((links: OrgLinks) => {
          localStorage.setItem("orgLinks", JSON.stringify(links));
          return links;
        },
        (error) => {
          throw error;
        });
  }

  public async getSmsTemplates(blockId?: string): Promise<Array<SmsTemplate>> {
    const sb = [];
    sb.push('rest');
    sb.push('/getSmsTemplates');
    return await this.httpService.getDataWithLocalAuth(sb.join(''), blockId)
      .then((templates: Array<SmsTemplate>) => {
          return templates;
        },
        (error) => {
          throw error;
        });
  }

  public async isHasSmsConfirmation(alias: string) {
    const sb = [];
    sb.push('rest/isHasSmsConfirmation?');
    sb.push('&alias=');
    sb.push(alias);

    let result = false;
    await this.httpService.getData(sb.join(''))
      .then((isHasSmsConfirmation) => {
        console.log("in org service isHasSmsConfirmation result: ", isHasSmsConfirmation);
        result = isHasSmsConfirmation;
      });
    return result;
  }


  private getErrorMessage(errorToken: WebResult): WebResult {
    if(errorToken.messageToken == ErrorTokens.SMS_TEMPLATE_ALREADY_EXISTS){
      return new WebResult("Шаблон с таким именем уже существует", errorToken.isSuccess);
    }
    return new WebResult("Что-то пошло не так", false);
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/_service/organization.service.ts